export default "__VITE_ASSET__BJ$Ro0Yf__"